import axios from 'axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        destroy(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/pengajuan/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        list(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/pengajuan', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        approve(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/pengajuan/approve/' + id )
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        reject(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/pengajuan/reject/' + data.id, data )
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
